/* @flow */
import React from 'react';

import LocalUserSettings from 'lib/LocalUserSettings';
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
import WebNotificationPreAskModal from 'notifications/WebNotificationPreAskModal.jsx';
import WebNotificationStore from 'notifications/WebNotificationStore';
import { mountModal } from 'lib/modal';

const MILLIS_PER_DAY = 24 * 60 * 60 * 1000;

const promptDefs = {
  [PromptNames.DESKTOP_NOTIFICATION_MODAL]: {
    /*
      reAskIntervals is the intervals of time that we show the modal.
        e.g., we show the modal on the 0th day, the 4rd day after, then the 4th day after that
      The notification preask modal is shown under the following conditions:
      - The notifications are compatible
      - Browser settings is either 'granted' or 'default'
        - If another user granted browser permission for notifications,
          we still have to show the modal for enabling it for another user
      - User permission is false (which is by default)
      - We have shown the modal less times than we have reAskIntervals
      - If either (there is no last prompt) or (if the time since the last prompt
        is longer than the last interval)
    */
    meetsCondition() {
      // all the logic below depends on being able to record prompts
      if (!LocalUserSettings.isEnabled()) {
        return false;
      }

      const prompts = LocalUserSettings.getUserProperties().prompts
        .filter(prompt => prompt.name === PromptNames.DESKTOP_NOTIFICATION_MODAL)
        .sort((p1, p2) => p1.date - p2.date);
      const lastPrompt = prompts.length > 0 ? prompts[prompts.length - 1] : null;

      const reAskIntervals = [0, 4, 4].map(days => days * MILLIS_PER_DAY);

      return WebNotificationStore.areNotificationsCompatible()
        && WebNotificationStore.getBrowserPermission() !== 'denied'
        && !WebNotificationStore.areNotificationsUserEnabled()
        && prompts.length < reAskIntervals.length
        && (!lastPrompt || lastPrompt.date < Date.now() - reAskIntervals[prompts.length]);
    },

    display(triggeredContext, thisContext) {
      mountModal(<WebNotificationPreAskModal triggeredContext={triggeredContext} />, thisContext);
      PromptActions.recordDismissal(PromptNames.DESKTOP_NOTIFICATION_MODAL);
      const properties = LocalUserSettings.getUserProperties();
      properties.prompts.push({
        name: PromptNames.DESKTOP_NOTIFICATION_MODAL,
        date: Date.now(),
      });
      LocalUserSettings.updateUser(properties);
    },
  },
};

export const showPromptDialog = (promptName: string, triggeredContext: string, thisContext: mixed) => {
  const prompt = promptDefs[promptName];
  if (prompt && prompt.meetsCondition()) {
    prompt.display(triggeredContext, thisContext);
  }
};



// WEBPACK FOOTER //
// ./src/components/promptDialog.jsx